import { useReduxState } from 'hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ProgressBar } from 'components/common';
import { ProgressLabel } from '.';

interface Props {
  analyticsDisabledForAdmin?: boolean;
  discrepancyInCompletion?: boolean;
  readingProgress: number;
  readingProgressMaxTime?: number;
  showLabelTitle?: boolean;
}

const ReadingProgress = ({
  analyticsDisabledForAdmin,
  discrepancyInCompletion,
  readingProgress,
  readingProgressMaxTime,
  showLabelTitle
}: Props) => {
  const { messages, theme } = useReduxState();

  if (readingProgressMaxTime === 0) {
    return (
      <div
        style={{
          color: theme.textColorLighter,
          fontSize: '1.3rem',
          whiteSpace: 'nowrap'
        }}
      >
        {messages.commonNoContent}
      </div>
    );
  }

  return (
    <div className="progress">
      <ProgressBar
        ariaLabel={messages.tasksReading}
        color="rgba(0, 0, 0, 0.4)"
        label={
          <ProgressLabel
            analyticsDisabledForAdmin={analyticsDisabledForAdmin}
            discrepancyInCompletion={discrepancyInCompletion}
            title={showLabelTitle ? messages.tasksReading : undefined}
            value={`${Math.round(readingProgress * 100)}%`}
          />
        }
        progress={readingProgress}
        style={{ width: showLabelTitle ? '100%' : 64 }}
      />
    </div>
  );
};

export default ReadingProgress;
